import { useEffect } from "react";
import { Tabs } from "antd";
import { useHistory, useLocation } from "react-router-dom";
import { MSCDAccountWidget } from "@/widgets/mscdaccount";
import { MSCDErrorAccountsWidget } from "@/widgets/mscdaccount/ErrorAccounts";

const TABS = [
  {
    key: "accounts",
    label: "Үнэт цаасны данс",
    children: <MSCDAccountWidget />,
  },
  {
    key: "error-accounts",
    label: "Алдаатай данс",
    children: <MSCDErrorAccountsWidget />,
  },
];

export const MSCDAccountPage = () => {
  const location = useLocation();
  const history = useHistory();
  const activeTab = location.hash?.replace("#", "") || "accounts";

  useEffect(() => {
    document.title = "Үнэт цаасны данс";
  }, []);

  return (
    <div className="page">
      <Tabs
        activeKey={activeTab}
        onChange={(key) => history.replace(`#${key}`)}
        items={TABS}
      />
    </div>
  );
};
